import extend from 'lodash/extend';
import first from 'lodash/first';
import isUndefined from 'lodash/isUndefined';
import Breadcrumb from '@Services/Breadcrumb';
import HistoryHelper from '@Services/HistoryHelper';
import History from '@Services/History';
import { dispatchCreateAlert } from '@Pages/Alerts/AlertsComponents/AlertCreateDialog/AlertCreateDialogActions';
import { isAlertVisible as isAlertVisibleString } from '@Pages/Alerts/AlertsUtils';
import BatchExecutionDetails from '@Services/BatchExecutionDetails';
import { openBatchExecutionDetailsModal } from '@Services/BatchExecutionDetails/BatchExecutionDetailsHelper';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import { generateHeatmapPath, generateResultsPath } from '@AppRoutes/utils';

// eslint-disable-next-line consistent-return
async function _checkBatchSearch(firstCrumb) {
  if (firstCrumb) {
    const details = await BatchExecutionDetails.getDetailsForBreadcrumb(firstCrumb);

    return details
      ? {
          batchSearch: true,
          batchComment: [details.filename, details.items.length, 'queries'].join(' '),
        }
      : null;
  }
}

export async function retrieveBreadcrumbs(databaseId) {
  const breadcrumbs = Breadcrumb.retrieveBreadcrumbs(databaseId);
  const batchSearch = await _checkBatchSearch(first(breadcrumbs));
  // eslint-disable-next-line no-unused-expressions
  batchSearch && extend(first(breadcrumbs), batchSearch);

  return breadcrumbs;
}

export function goToResultPage(breadcrumb) {
  if (!breadcrumb.active) {
    // eslint-disable-next-line no-param-reassign
    if (isUndefined(breadcrumb.limitOrExclude)) breadcrumb.limitOrExclude = '';

    if (breadcrumb.isHeatmapShown) {
      Breadcrumb.updateBreadcrumbs(breadcrumb);

      const stateParams = { ...breadcrumb };
      stateParams.resultName = breadcrumb.heatmapResultName;
      stateParams.context = 'dpitems';
      stateParams.sortedMatrixName = stateParams.sortedMatrixName || null;
      const pathName = generateHeatmapPath(stateParams);
      history.push({
        pathname: pathName,
        state: stateParams,
      });
    } else {
      const { resultName, databaseId, isHeatmapShown } = breadcrumb;
      Breadcrumb.activateBreadcrumb(resultName, databaseId, isHeatmapShown);
      const pathName = generateResultsPath(breadcrumb);
      history.push({
        pathname: pathName,
        state: breadcrumb,
      });
    }
  }
}

export function backToQueryHandler(breadcrumb, action) {
  if (!breadcrumb.isFromAdvancedSearch && !breadcrumb.isHistoryBreadcrumb) {
    history.push({
      pathname: action === 'preview' ? paths.PREVIEW : paths.SEARCH,
      state: { action },
    });
  } else if (breadcrumb.isHistoryBreadcrumb) {
    HistoryHelper.copyQuery(breadcrumb);
  } else {
    history.push(paths.ADVANCED);
  }
}

export function isAlertVisible(breadcrumb) {
  return !!isAlertVisibleString(breadcrumb);
}

export function createAlert(breadcrumb) {
  return dispatchCreateAlert(breadcrumb);
}

// formatNewHistory is mutating breadcrumb object -_-
export async function updateBreadcrumbData(breadcrumb) {
  await History.formatNewHistory(breadcrumb);
  return breadcrumb;
}

export function openBatchExecutionDetails(breadcrumb) {
  return openBatchExecutionDetailsModal(breadcrumb, BatchExecutionDetails.unregisterSockets);
}

export function showStructurePopup(structure) {
  return History.showStructurePopup(structure);
}
